import { render } from "./Principal.vue?vue&type=template&id=402ae4dc"
import script from "./Principal.vue?vue&type=script&lang=js"
export * from "./Principal.vue?vue&type=script&lang=js"
script.render = render

export default script